/**
 * districts.gen.ts — 자동 생성 파일. 직접 편집하지 마세요.
 *
 * 생성: node tools/migration/gen_district_dict.js
 * 출처: 행정안전부 법정동코드 전체자료
 *
 * 대상 시군 (sales_sites 실측 빈도 기준):
 *   전라남도 영광군 · 전라남도 함평군 · 전라남도 장성군 · 전라남도 무안군 · 전라북도 고창군
 *
 * 전남 전체를 넣지 않는 이유 — "관리·수리·정리·대리·심리·원리·지리·진리"가 다른 시군의
 * 실제 법정리라서, 사전에 들어오면 "중점관리지역"·"하수처리시설"을 쪼갠다.
 */

/** 시·군·구 — 앞에 지역명이 붙은 온전한 형태일 때만 끊는다 */
export const DISTRICTS: readonly string[] = [
  "고창군", "무안군", "영광군", "장성군", "함평군",
];

/** 읍·면 — ERP 는 접미사를 떼고 "염산"으로만 적는다 */
export const TOWNSHIPS: readonly string[] = [
  "고수", "고창", "공음", "군남", "군서", "나산", "낙월", "대동",
  "대마", "대산", "도초", "동화", "망운", "몽탄", "묘량", "무안",
  "무장", "백수", "법성", "부안", "북상", "북이", "북일", "북하",
  "불갑", "비금", "삼계", "삼서", "삼향", "상하", "서삼", "성내",
  "성송", "손불", "신광", "신림", "심원", "아산", "안좌", "암태",
  "압해", "엄다", "염산", "영광", "운남", "월야", "이로", "일로",
  "자은", "장산", "장성", "지도", "진원", "청계", "추자", "하의",
  "학교", "함평", "해리", "해보", "해제", "현경", "홍농", "황룡",
  "흑산", "흥덕",
];

/** 리(里) — 법정리 이름. 일반 한자어와 겹치는 것은 제외했다 */
export const VILLAGES: readonly string[] = [
  "가거도리", "가곡리", "가덕리", "가동리", "가란리", "가룡리", "가사리", "가산리",
  "가입리", "가평리", "각이리", "갈마리", "감돈리", "감정리", "강남리", "강운리",
  "강정리", "건동리", "건무리", "검산리", "계당리", "계림리", "계마리", "계산리",
  "계송리", "계천리", "고라리", "고란리", "고막리", "고서리", "고성리", "고이리",
  "고장리", "고전리", "고절리", "곡창리", "공수리", "관동리", "광대리", "광산리",
  "광승리", "광암리", "광정리", "괴치리", "교운리", "교촌리", "교흥리", "구대리",
  "구로리", "구룡리", "구림리", "구산리", "구수리", "구암리", "구영리", "구정리",
  "군유리", "궁산리", "귀학리", "금계리", "금곡리", "금덕리", "금산리", "금송리",
  "금평리", "금호리", "기각리", "기동리", "기산리", "길룡리", "길용리", "나산리",
  "낙양리", "남강리", "남계리", "남산리", "남성리", "남악리", "남안리", "남죽리",
  "남창리", "남천리", "남평리", "내계리", "내교리", "내동리", "내리", "내월리",
  "내장리", "내호리", "노동리", "녹사리", "녹산리", "녹진리", "논산리", "눌도리",
  "능산리", "능성리", "다산리", "다수리", "다촌리", "단고리", "단광리", "단덕리",
  "단전리", "단주리", "달리", "달산리", "달성리", "당고리", "당사리", "당촌리",
  "당호리", "대각리", "대곡리", "대기리", "대덕리", "대도리", "대동리", "대사리",
  "대신리", "대심리", "대악리", "대양리", "대우리", "대율리", "대장리", "대전리",
  "대창리", "대척리", "대천리", "대초리", "대치리", "대흥리", "덕림리", "덕산리",
  "덕성리", "덕암리", "덕재리", "덕정리", "덕진리", "덕천리", "덕호리", "덕화리",
  "덕흥리", "도곡리", "도길리", "도대리", "도동리", "도림리", "도산리", "도장리",
  "도찬리", "도창리", "도천리", "동간리", "동사리", "동산리", "동서리", "동암리",
  "동월리", "동정리", "동현리", "동호리", "두암리", "두어리", "두우리", "두월리",
  "두평리", "라성리", "마령리", "마명리", "마산리", "마읍리", "마진도리", "마진리",
  "만곡리", "만금리", "만년리", "만돌리", "만무리", "만풍리", "만화리", "만흥리",
  "망월리", "매곡리", "매산리", "매화리", "맥포리", "맥호리", "면전리", "명산리",
  "모악리", "모암리", "모현리", "목동리", "목서리", "목우리", "몽강리", "무령리",
  "무림리", "무송리", "무장리", "문암리", "문장리", "박산리", "박지리", "반룡리",
  "반안리", "반암리", "반월리", "발매리", "발산리", "방마리", "방월리", "방축리",
  "백계리", "백산리", "백암리", "백양리", "백운리", "백학리", "백호리", "법성리",
  "법지리", "벽송리", "병풍리", "보라리", "보생리", "보여리", "복길리", "복룡리",
  "복천리", "복평리", "복호리", "복흥리", "봉남리", "봉덕리", "봉리", "봉명리",
  "봉산리", "봉암리", "부곡리", "부덕리", "부성리", "부송리", "부춘리", "부흥리",
  "북성리", "분매리", "분향리", "비리", "사거리", "사내리", "사리", "사마리",
  "사반리", "사창리", "사천리", "사포리", "산길리", "산남리", "산내리", "산동리",
  "산두리", "산림리", "산수리", "산정리", "삼계리", "삼당리", "삼덕리", "삼두리",
  "삼인리", "삼정리", "삼축리", "삼태리", "삼학리", "삼효리", "상갑리", "상계리",
  "상곡리", "상금리", "상낙월리", "상도리", "상등리", "상리", "상림리", "상마리",
  "상사리", "상신기리", "상암리", "상오리", "상옥리", "상태동리", "상태서리", "상평리",
  "상하리", "생곡리", "생촌리", "서양리", "서호리", "석교리", "석남리", "석룡리",
  "석마리", "석만리", "석성리", "석우리", "석정리", "석창리", "석현리", "선도리",
  "선동리", "선운리", "선적리", "설매리", "성남리", "성내리", "성덕리", "성동리",
  "성두리", "성산리", "성암리", "성천리", "세곡리", "소곡리", "소룡리", "송계리",
  "송곡리", "송공리", "송로리", "송림리", "송사리", "송산리", "송석리", "송암리",
  "송용리", "송이리", "송정리", "송죽리", "송학리", "송현리", "수곡리", "수남리",
  "수다리", "수대리", "수도리", "수동리", "수산리", "수상리", "수성리", "수앙리",
  "수양리", "수옥리", "수치리", "수하리", "수항리", "수해리", "수호리", "순용리",
  "시서리", "신계리", "신기리", "신대리", "신덕리", "신석리", "신성리", "신송리",
  "신용리", "신원리", "신월리", "신장리", "신정리", "신천리", "신촌리", "신평리",
  "신하리", "신학리", "신호리", "신흥리", "쌍운리", "쌍웅리", "아곡리", "안맹리",
  "안산리", "안평리", "암리", "암치리", "야월리", "야은리", "약곡리", "약수리",
  "양간리", "양계리", "양덕리", "양매리", "양성리", "양월리", "양장리", "양재리",
  "양정리", "양평리", "양학리", "양호리", "어은리", "어의리", "엄다리", "여흘리",
  "연동리", "연리", "연성리", "연암리", "연화리", "영산리", "영양리", "영외리",
  "영월리", "영천리", "영흥리", "예덕리", "예리", "예전리", "예지리", "오도리",
  "오동리", "오룡리", "오류리", "오리", "오림리", "오산리", "오상리", "오월리",
  "오음리", "오호리", "옥도리", "옥산리", "옥실리", "옥암리", "옥정리", "옥제리",
  "와룡리", "와우리", "와촌리", "왕산리", "왕촌리", "외남리", "외반리", "외치리",
  "외화리", "용강리", "용계리", "용곡리", "용교리", "용기리", "용당리", "용대리",
  "용덕리", "용두리", "용반리", "용산리", "용성리", "용소리", "용수리", "용암리",
  "용월리", "용정리", "용포리", "용학리", "용흥리", "우곡리", "우이도리", "우전리",
  "우치리", "우평리", "운곡리", "운교리", "운당리", "운양리", "웅곡리", "원덕리",
  "원산리", "원선리", "원촌리", "원흥리", "월계리", "월곡리", "월림리", "월봉리",
  "월산리", "월선리", "월성리", "월송리", "월악리", "월암리", "월야리", "월연리",
  "월정리", "월천리", "월촌리", "월평리", "월호리", "월흥리", "유각리", "유교리",
  "유월리", "유천리", "유탕리", "유평리", "율계리", "율곡리", "율촌리", "은사리",
  "읍내리", "읍동리", "읍리", "응봉리", "의산리", "이곡리", "이목리", "이문리",
  "이산리", "이흑리", "인도리", "인성리", "임병리", "임성리", "임수리", "입석리",
  "입암리", "자동리", "자라리", "자룡리", "자비리", "자포리", "자풍리", "장감리",
  "장곡리", "장교리", "장년리", "장두리", "장산리", "장안리", "장촌리", "장호리",
  "재원리", "정산리", "제하리", "조동리", "조양리", "존포리", "주곡리", "주산리",
  "주진리", "죽도리", "죽림리", "죽사리", "죽산리", "죽암리", "죽연리", "죽장리",
  "죽정리", "죽청리", "중산리", "중월리", "중평리", "중흥리", "증동리", "지남리",
  "지당리", "지산리", "지석리", "지장리", "진고리", "진내리", "진덕리", "진리리",
  "진양리", "진원리", "창마리", "창매리", "천마리", "천장리", "천정리", "청계리",
  "청수리", "청용리", "청천리", "청호리", "초내리", "초포리", "추암리", "축동리",
  "춘산리", "치룡리", "칠곡리", "칠암리", "탄도리", "탄동리", "태도리", "태봉리",
  "태천리", "통안리", "판정리", "팽진리", "평룡리", "평산리", "평용리", "평지리",
  "포천리", "피서리", "필암리", "하갑리", "하고리", "하낙월리", "하남리", "하련리",
  "하묘리", "하사리", "하장리", "하전리", "하태동리", "하태서리", "학교리", "학림리",
  "학산리", "학성리", "학송리", "학야리", "학전리", "학정리", "학천리", "한운리",
  "함정리", "함평리", "해룡리", "해보리", "해운리", "행정리", "향교리", "향목리",
  "향산리", "현화리", "홍곡리", "홍교리", "홍정리", "화산리", "화양리", "화천리",
  "화평리", "황룡리", "황산리", "회룡리", "후광리", "후포리", "흥덕리",
];

/**
 * 리 → 상위 행정구역("영광군 염산면"). 주소를 완전한 형태로 보완할 때 쓴다.
 * 같은 이름의 리가 여러 읍면에 있으면(모호) 넣지 않는다 — 그런 경우는 지오코딩 결과에 맡긴다.
 */
export const VILLAGE_PARENTS: Readonly<Record<string, string>> = {
  "가거도리": "무안군 흑산면",
  "가덕리": "함평군 신광면",
  "가란리": "무안군 압해면",
  "가룡리": "무안군 압해면",
  "가사리": "영광군 군서면",
  "가산리": "무안군 비금면",
  "가입리": "무안군 현경면",
  "가평리": "고창군 신림면",
  "각이리": "영광군 낙월면",
  "갈마리": "고창군 대산면",
  "감정리": "무안군 지도면",
  "강남리": "고창군 무장면",
  "강운리": "함평군 대동면",
  "강정리": "무안군 청계면",
  "건동리": "고창군 공음면",
  "건무리": "영광군 불갑면",
  "계당리": "고창군 성송면",
  "계림리": "함평군 월야면",
  "계산리": "고창군 아산면",
  "계송리": "영광군 영광읍",
  "계천리": "함평군 신광면",
  "고라리": "고창군 무장면",
  "고란리": "무안군 도초면",
  "고막리": "함평군 학교면",
  "고서리": "무안군 비금면",
  "고성리": "고창군 해리면",
  "고이리": "무안군 압해면",
  "고장리": "무안군 자은면",
  "고전리": "고창군 심원면",
  "곡창리": "함평군 학교면",
  "공수리": "무안군 장산면",
  "관동리": "장성군 황룡면",
  "광승리": "고창군 해리면",
  "광정리": "무안군 지도면",
  "괴치리": "고창군 성송면",
  "교운리": "고창군 흥덕면",
  "교촌리": "영광군 영광읍",
  "교흥리": "고창군 무장면",
  "구대리": "무안군 안좌면",
  "구로리": "무안군 청계면",
  "구룡리": "장성군 동화면",
  "구영리": "무안군 자은면",
  "군유리": "고창군 공음면",
  "귀학리": "무안군 몽탄면",
  "금계리": "영광군 불갑면",
  "금덕리": "함평군 해보면",
  "금송리": "함평군 학교면",
  "금평리": "고창군 해리면",
  "금호리": "장성군 황룡면",
  "기동리": "무안군 암태면",
  "기산리": "장성군 장성읍",
  "길룡리": "영광군 백수면",
  "길용리": "영광군 백수읍",
  "나산리": "함평군 나산면",
  "낙양리": "고창군 성송면",
  "남강리": "무안군 안좌면",
  "남계리": "영광군 군서면",
  "남산리": "영광군 대마면",
  "남성리": "무안군 청계면",
  "남안리": "무안군 청계면",
  "남죽리": "영광군 군서면",
  "남창리": "영광군 군남면",
  "남천리": "영광군 영광읍",
  "남평리": "장성군 동화면",
  "내계리": "장성군 삼계면",
  "내동리": "고창군 고창읍",
  "내월리": "무안군 비금면",
  "내장리": "무안군 지도면",
  "내호리": "무안군 안좌면",
  "노동리": "고창군 고창읍",
  "녹산리": "영광군 불갑면",
  "녹진리": "장성군 남면",
  "눌도리": "무안군 이로면",
  "능산리": "무안군 하의면",
  "능성리": "장성군 삼계면",
  "다산리": "무안군 몽탄면",
  "다수리": "무안군 장산면",
  "다촌리": "무안군 흑산면",
  "단고리": "무안군 암태면",
  "단광리": "장성군 장성읍",
  "단전리": "장성군 북하면",
  "단주리": "영광군 영광읍",
  "달리": "무안군 이로면",
  "달산리": "무안군 몽탄면",
  "달성리": "장성군 북이면",
  "당고리": "무안군 안좌면",
  "당사리": "무안군 암태면",
  "당촌리": "무안군 지도면",
  "당호리": "무안군 몽탄면",
  "대각리": "함평군 해보면",
  "대곡리": "장성군 삼서면",
  "대기리": "무안군 추자면",
  "대도리": "장성군 삼서면",
  "대동리": "고창군 아산면",
  "대사리": "무안군 해제면",
  "대심리": "무안군 안좌면",
  "대악리": "장성군 북하면",
  "대우리": "무안군 안좌면",
  "대율리": "무안군 자은면",
  "대장리": "고창군 대산면",
  "대창리": "함평군 해보면",
  "대척리": "무안군 안좌면",
  "대천리": "무안군 압해면",
  "대초리": "무안군 지도면",
  "대치리": "무안군 몽탄면",
  "덕산리": "영광군 군서면",
  "덕성리": "장성군 남면",
  "덕암리": "고창군 공음면",
  "덕정리": "고창군 고창읍",
  "덕진리": "장성군 장성읍",
  "덕천리": "고창군 대산면",
  "덕호리": "영광군 영광읍",
  "덕화리": "고창군 신림면",
  "도곡리": "고창군 무장면",
  "도길리": "무안군 비금면",
  "도대리": "무안군 청계면",
  "도동리": "영광군 영광읍",
  "도산리": "고창군 고창읍",
  "도장리": "영광군 군남면",
  "도찬리": "무안군 추자면",
  "도천리": "고창군 심원면",
  "동간리": "영광군 군남면",
  "동사리": "고창군 흥덕면",
  "동서리": "무안군 압해면",
  "동월리": "영광군 군남면",
  "동정리": "함평군 신광면",
  "두암리": "고창군 공음면",
  "두어리": "고창군 심원면",
  "두우리": "영광군 염산면",
  "두월리": "장성군 삼서면",
  "두평리": "고창군 고수면",
  "라성리": "고창군 해리면",
  "마령리": "장성군 남면",
  "마명리": "무안군 안좌면",
  "마읍리": "영광군 군서면",
  "마진도리": "무안군 장산면",
  "마진리": "무안군 안좌면",
  "만곡리": "영광군 군서면",
  "만금리": "영광군 군서면",
  "만년리": "무안군 도초면",
  "만돌리": "고창군 심원면",
  "만무리": "장성군 북이면",
  "만풍리": "무안군 해제면",
  "만화리": "고창군 무장면",
  "매산리": "영광군 군서면",
  "매화리": "무안군 압해면",
  "맥호리": "장성군 황룡면",
  "면전리": "무안군 자은면",
  "명산리": "무안군 몽탄면",
  "모악리": "영광군 불갑면",
  "모암리": "장성군 서삼면",
  "모현리": "장성군 북이면",
  "목서리": "무안군 망운면",
  "목우리": "고창군 무장면",
  "몽강리": "무안군 몽탄면",
  "무령리": "영광군 영광읍",
  "무림리": "고창군 신림면",
  "무송리": "고창군 성송면",
  "무장리": "고창군 무장면",
  "문암리": "장성군 북일면",
  "문장리": "함평군 해보면",
  "박산리": "장성군 북일면",
  "박지리": "무안군 안좌면",
  "반룡리": "고창군 신림면",
  "반암리": "고창군 아산면",
  "반월리": "무안군 안좌면",
  "발매리": "무안군 도초면",
  "발산리": "장성군 삼계면",
  "방마리": "영광군 불갑면",
  "방월리": "무안군 안좌면",
  "백계리": "장성군 장성읍",
  "백산리": "무안군 자은면",
  "백양리": "영광군 군남면",
  "백운리": "함평군 신광면",
  "백학리": "영광군 영광읍",
  "법성리": "영광군 법성면",
  "법지리": "고창군 신림면",
  "벽송리": "고창군 신림면",
  "병풍리": "무안군 지도면",
  "보라리": "영광군 군서면",
  "보생리": "장성군 삼서면",
  "보여리": "함평군 신광면",
  "복길리": "무안군 청계면",
  "복천리": "함평군 학교면",
  "복평리": "영광군 대마면",
  "복호리": "무안군 안좌면",
  "복흥리": "함평군 신광면",
  "봉남리": "영광군 염산면",
  "봉리": "무안군 지도면",
  "봉명리": "무안군 몽탄면",
  "봉암리": "고창군 부안면",
  "부곡리": "고창군 고수면",
  "부덕리": "고창군 성내면",
  "부성리": "장성군 삼계면",
  "부송리": "고창군 신림면",
  "부춘리": "영광군 불갑면",
  "부흥리": "장성군 장성읍",
  "북성리": "함평군 손불면",
  "분매리": "무안군 압해면",
  "분향리": "장성군 남면",
  "비리": "무안군 흑산면",
  "사내리": "고창군 성송면",
  "사리": "무안군 흑산면",
  "사마리": "무안군 청계면",
  "사반리": "고창군 해리면",
  "사포리": "고창군 흥덕면",
  "산길리": "무안군 해제면",
  "산남리": "함평군 손불면",
  "산내리": "함평군 해보면",
  "산동리": "장성군 진원면",
  "산두리": "무안군 안좌면",
  "산림리": "고창군 성내면",
  "산수리": "고창군 성송면",
  "삼계리": "장성군 삼서면",
  "삼당리": "영광군 법성면",
  "삼덕리": "함평군 신광면",
  "삼두리": "무안군 추자면",
  "삼인리": "고창군 아산면",
  "삼정리": "함평군 엄다면",
  "삼축리": "함평군 나산면",
  "삼태리": "장성군 남면",
  "삼학리": "영광군 묘량면",
  "삼효리": "영광군 묘량면",
  "상갑리": "고창군 아산면",
  "상계리": "영광군 염산면",
  "상곡리": "함평군 해보면",
  "상낙월리": "영광군 낙월면",
  "상도리": "장성군 삼계면",
  "상등리": "고창군 부안면",
  "상리": "무안군 이로면",
  "상림리": "장성군 진원면",
  "상마리": "무안군 청계면",
  "상암리": "고창군 부안면",
  "상오리": "장성군 장성읍",
  "상태동리": "무안군 하의면",
  "상태서리": "무안군 하의면",
  "상평리": "고창군 고수면",
  "생곡리": "영광군 불갑면",
  "생촌리": "장성군 삼계면",
  "서양리": "장성군 동화면",
  "석남리": "고창군 상하면",
  "석룡리": "무안군 해제면",
  "석마리": "장성군 삼서면",
  "석만리": "영광군 낙월면",
  "석우리": "고창군 흥덕면",
  "석창리": "함평군 손불면",
  "선도리": "무안군 지도면",
  "선동리": "고창군 공음면",
  "선운리": "고창군 부안면",
  "선적리": "장성군 진원면",
  "설매리": "영광군 군남면",
  "성덕리": "장성군 북일면",
  "성두리": "고창군 고창읍",
  "성천리": "함평군 엄다면",
  "세곡리": "고창군 신림면",
  "소곡리": "무안군 안좌면",
  "소룡리": "장성군 삼서면",
  "송공리": "무안군 압해면",
  "송로리": "함평군 엄다면",
  "송사리": "함평군 신광면",
  "송석리": "무안군 해제면",
  "송암리": "영광군 염산면",
  "송용리": "고창군 신림면",
  "송이리": "영광군 낙월면",
  "송정리": "무안군 현경면",
  "송죽리": "영광군 대마면",
  "송학리": "영광군 군서면",
  "수곡리": "무안군 암태면",
  "수남리": "고창군 부안면",
  "수다리": "무안군 도초면",
  "수대리": "무안군 비금면",
  "수도리": "무안군 추자면",
  "수동리": "고창군 부안면",
  "수상리": "함평군 나산면",
  "수앙리": "고창군 부안면",
  "수옥리": "장성군 삼계면",
  "수치리": "무안군 비금면",
  "수하리": "함평군 나산면",
  "수항리": "무안군 도초면",
  "수해리": "장성군 삼서면",
  "순용리": "영광군 불갑면",
  "시서리": "무안군 안좌면",
  "신계리": "함평군 엄다면",
  "신기리": "영광군 낙월면",
  "신덕리": "고창군 흥덕면",
  "신성리": "영광군 염산면",
  "신송리": "고창군 흥덕면",
  "신용리": "무안군 압해면",
  "신원리": "무안군 비금면",
  "신월리": "영광군 영광읍",
  "신장리": "영광군 법성면",
  "신정리": "무안군 해제면",
  "신천리": "영광군 묘량면",
  "신학리": "무안군 무안읍",
  "신호리": "장성군 황룡면",
  "신흥리": "장성군 북일면",
  "쌍운리": "영광군 불갑면",
  "아곡리": "장성군 황룡면",
  "안맹리": "영광군 불갑면",
  "안산리": "고창군 해리면",
  "안평리": "장성군 장성읍",
  "암리": "무안군 추자면",
  "암치리": "고창군 성송면",
  "야월리": "영광군 염산면",
  "야은리": "장성군 장성읍",
  "약곡리": "무안군 몽탄면",
  "양간리": "무안군 해제면",
  "양계리": "고창군 성내면",
  "양덕리": "영광군 군남면",
  "양매리": "무안군 해제면",
  "양월리": "무안군 해제면",
  "양장리": "무안군 몽탄면",
  "양재리": "함평군 손불면",
  "양정리": "함평군 월야면",
  "양평리": "영광군 영광읍",
  "양학리": "무안군 현경면",
  "양호리": "무안군 일로읍",
  "어은리": "무안군 하의면",
  "어의리": "무안군 지도면",
  "엄다리": "함평군 엄다면",
  "여흘리": "무안군 안좌면",
  "연동리": "고창군 대산면",
  "연성리": "영광군 영광읍",
  "연암리": "영광군 묘량면",
  "연화리": "고창군 심원면",
  "영산리": "무안군 흑산면",
  "영양리": "영광군 묘량면",
  "영외리": "영광군 낙월면",
  "영월리": "함평군 월야면",
  "영천리": "장성군 장성읍",
  "영흥리": "함평군 엄다면",
  "예덕리": "함평군 월야면",
  "예리": "무안군 흑산면",
  "예전리": "고창군 공음면",
  "예지리": "고창군 고수면",
  "오도리": "영광군 낙월면",
  "오룡리": "무안군 일로읍",
  "오리": "무안군 흑산면",
  "오림리": "무안군 하의면",
  "오상리": "무안군 암태면",
  "오음리": "무안군 장산면",
  "오호리": "고창군 흥덕면",
  "옥도리": "무안군 하의면",
  "옥정리": "장성군 황룡면",
  "옥제리": "고창군 성내면",
  "와룡리": "영광군 영광읍",
  "와우리": "장성군 황룡면",
  "왕촌리": "고창군 해리면",
  "외남리": "무안군 도초면",
  "외반리": "무안군 현경면",
  "외치리": "함평군 월야면",
  "외화리": "고창군 신림면",
  "용강리": "장성군 장성읍",
  "용계리": "고창군 아산면",
  "용교리": "고창군 성내면",
  "용기리": "고창군 심원면",
  "용당리": "무안군 이로면",
  "용대리": "고창군 상하면",
  "용덕리": "영광군 법성면",
  "용반리": "고창군 흥덕면",
  "용성리": "영광군 법성면",
  "용소리": "무안군 비금면",
  "용수리": "고창군 공음면",
  "용암리": "영광군 군남면",
  "용학리": "무안군 해제면",
  "용흥리": "장성군 서삼면",
  "우곡리": "영광군 불갑면",
  "우이도리": "무안군 도초면",
  "우전리": "무안군 지도면",
  "우평리": "영광군 영광읍",
  "운곡리": "고창군 아산면",
  "운교리": "함평군 대동면",
  "운당리": "영광군 묘량면",
  "운양리": "고창군 부안면",
  "웅곡리": "무안군 하의면",
  "원덕리": "장성군 북이면",
  "원선리": "함평군 나산면",
  "원촌리": "고창군 무장면",
  "원흥리": "영광군 대마면",
  "월림리": "고창군 무장면",
  "월봉리": "함평군 나산면",
  "월선리": "무안군 청계면",
  "월악리": "함평군 월야면",
  "월야리": "함평군 월야면",
  "월연리": "장성군 삼계면",
  "월정리": "장성군 남면",
  "월천리": "함평군 손불면",
  "월촌리": "영광군 낙월면",
  "월평리": "영광군 영광읍",
  "월호리": "함평군 학교면",
  "유각리": "무안군 자은면",
  "유월리": "무안군 해제면",
  "유탕리": "장성군 장성읍",
  "유평리": "장성군 삼서면",
  "율계리": "고창군 고창읍",
  "율곡리": "장성군 진원면",
  "율촌리": "고창군 대산면",
  "은사리": "고창군 고수면",
  "읍동리": "무안군 안좌면",
  "읍리": "무안군 안좌면",
  "응봉리": "영광군 불갑면",
  "이곡리": "무안군 도초면",
  "이목리": "무안군 안좌면",
  "이문리": "함평군 나산면",
  "이산리": "무안군 몽탄면",
  "이흑리": "무안군 추자면",
  "인도리": "무안군 흑산면",
  "인성리": "고창군 고수면",
  "임병리": "영광군 낙월면",
  "임수리": "무안군 해제면",
  "입석리": "영광군 영광읍",
  "입암리": "영광군 법성면",
  "자동리": "무안군 지도면",
  "자라리": "무안군 안좌면",
  "자룡리": "고창군 상하면",
  "자비리": "영광군 불갑면",
  "자포리": "고창군 신림면",
  "장감리": "무안군 압해면",
  "장곡리": "고창군 공음면",
  "장두리": "고창군 고수면",
  "장안리": "장성군 장성읍",
  "장촌리": "무안군 안좌면",
  "장호리": "고창군 상하면",
  "재원리": "무안군 추자면",
  "정산리": "함평군 월야면",
  "조동리": "고창군 성내면",
  "존포리": "무안군 안좌면",
  "주곡리": "고창군 고창읍",
  "주진리": "고창군 아산면",
  "죽도리": "영광군 낙월면",
  "죽암리": "함평군 손불면",
  "죽연리": "무안군 도초면",
  "죽장리": "함평군 손불면",
  "죽정리": "함평군 학교면",
  "죽청리": "장성군 북이면",
  "중산리": "고창군 대산면",
  "중월리": "고창군 아산면",
  "중평리": "장성군 북하면",
  "중흥리": "고창군 부안면",
  "증동리": "무안군 지도면",
  "지남리": "무안군 도초면",
  "지당리": "무안군 비금면",
  "지석리": "고창군 대산면",
  "진고리": "무안군 안좌면",
  "진내리": "영광군 법성면",
  "진리리": "무안군 추자면",
  "진원리": "장성군 진원면",
  "창마리": "무안군 안좌면",
  "창매리": "무안군 해제면",
  "천장리": "무안군 해제면",
  "청계리": "무안군 청계면",
  "청수리": "무안군 청계면",
  "청용리": "무안군 몽탄면",
  "청천리": "무안군 청계면",
  "초내리": "고창군 고수면",
  "초포리": "함평군 나산면",
  "추암리": "장성군 서삼면",
  "축동리": "영광군 염산면",
  "춘산리": "고창군 대산면",
  "치룡리": "고창군 흥덕면",
  "칠암리": "고창군 공음면",
  "탄도리": "무안군 망운면",
  "태도리": "무안군 흑산면",
  "태봉리": "무안군 청계면",
  "태천리": "무안군 지도면",
  "통안리": "장성군 황룡면",
  "판정리": "고창군 성송면",
  "팽진리": "무안군 장산면",
  "평용리": "무안군 무안읍",
  "포천리": "영광군 군남면",
  "피서리": "무안군 망운면",
  "필암리": "장성군 황룡면",
  "하갑리": "고창군 아산면",
  "하고리": "고창군 성송면",
  "하낙월리": "영광군 낙월면",
  "하남리": "고창군 흥덕면",
  "하련리": "고창군 해리면",
  "하장리": "고창군 상하면",
  "하전리": "고창군 심원면",
  "하태동리": "무안군 하의면",
  "하태서리": "무안군 하의면",
  "학림리": "장성군 진원면",
  "학성리": "장성군 삼서면",
  "학송리": "무안군 해제면",
  "학야리": "함평군 엄다면",
  "학천리": "고창군 성송면",
  "함정리": "함평군 신광면",
  "해룡리": "고창군 대산면",
  "해보리": "함평군 해보면",
  "해운리": "무안군 현경면",
  "행정리": "장성군 남면",
  "향교리": "함평군 대동면",
  "향목리": "무안군 안좌면",
  "향산리": "고창군 성송면",
  "현화리": "무안군 현경면",
  "홍교리": "영광군 대마면",
  "홍정리": "장성군 삼서면",
  "화양리": "함평군 엄다면",
  "화천리": "영광군 법성면",
  "화평리": "영광군 대마면",
  "황룡리": "장성군 황룡면",
  "황산리": "고창군 고수면",
  "회룡리": "고창군 대산면",
  "후광리": "무안군 하의면",
  "후포리": "고창군 흥덕면",
  "흥덕리": "고창군 흥덕면",
};

/** 읍면 → 시군("영광군") */
export const TOWNSHIP_PARENTS: Readonly<Record<string, string>> = {
  "고수면": "고창군",
  "고창읍": "고창군",
  "공음면": "고창군",
  "군남면": "영광군",
  "군서면": "영광군",
  "나산면": "함평군",
  "낙월면": "영광군",
  "남면": "장성군",
  "대동면": "함평군",
  "대마면": "영광군",
  "대산면": "고창군",
  "도초면": "무안군",
  "동화면": "장성군",
  "망운면": "무안군",
  "몽탄면": "무안군",
  "묘량면": "영광군",
  "무안면": "무안군",
  "무안읍": "무안군",
  "무장면": "고창군",
  "백수면": "영광군",
  "백수읍": "영광군",
  "법성면": "영광군",
  "부안면": "고창군",
  "북상면": "장성군",
  "북이면": "장성군",
  "북일면": "장성군",
  "북하면": "장성군",
  "불갑면": "영광군",
  "비금면": "무안군",
  "삼계면": "장성군",
  "삼서면": "장성군",
  "삼향면": "무안군",
  "삼향읍": "무안군",
  "상하면": "고창군",
  "서삼면": "장성군",
  "성내면": "고창군",
  "성송면": "고창군",
  "손불면": "함평군",
  "신광면": "함평군",
  "신림면": "고창군",
  "심원면": "고창군",
  "아산면": "고창군",
  "안좌면": "무안군",
  "암태면": "무안군",
  "압해면": "무안군",
  "엄다면": "함평군",
  "염산면": "영광군",
  "영광읍": "영광군",
  "운남면": "무안군",
  "월야면": "함평군",
  "이로면": "무안군",
  "일로면": "무안군",
  "일로읍": "무안군",
  "자은면": "무안군",
  "장산면": "무안군",
  "장성읍": "장성군",
  "지도면": "무안군",
  "진원면": "장성군",
  "청계면": "무안군",
  "추자면": "무안군",
  "하의면": "무안군",
  "학교면": "함평군",
  "함평면": "함평군",
  "함평읍": "함평군",
  "해리면": "고창군",
  "해보면": "함평군",
  "해제면": "무안군",
  "현경면": "무안군",
  "홍농면": "영광군",
  "홍농읍": "영광군",
  "황룡면": "장성군",
  "흑산면": "무안군",
  "흥덕면": "고창군",
};
